/**
 * @author Manne Hareesh
 * @description Reducer for the components in home page
 */
import {
    SET_DESTINATION_CITIES,
    SET_ORIGIN_CITIES,
    SET_SELECTED_SCHEDULE_SEATS,
    SET_SELECTED_SCHEDULE,
    LOG_OUT_ACTION,
    SET_BOOKED_TICKET,
    SET_PICK_UP_POINTS_DETAILS_SELECTED_SCHEDULE,
    SET_DROP_UP_POINTS_DETAILS_SELECTED_SCHEDULE
 } from '../actions/action-types';
import { isValidArray, isValid, isValidArrayWithValues } from '../utils/utilities';
  
  const initialState = {
      origins: undefined,
      originSupportedDestinations:undefined,
      selectedScheduleSeats:undefined,
      selectedSchedule:undefined,
      bookedTicketObject:undefined,
      dropTimingsByTripCity:undefined
  }

  const formatScheduleSeats = (scheduleSeats) => {
    if (!isValidArray(scheduleSeats)) {
      return scheduleSeats;
    }

    // First pass: Build PNR mapping with totals
    let pnrData = {};
    
    scheduleSeats.forEach((seat) => {
      // Handle passenger PNRs
      if (isValidArrayWithValues(seat.passengers)) {
        seat.passengers.forEach((passenger) => {
          if (isValid(passenger.pnr)) {
            if (!pnrData[passenger.pnr]) {
              pnrData[passenger.pnr] = {
                seatNumbers: [],
                totalDiscountedFare: 0,
                totalGst: 0,
                totalAmountPaid: 0,
                totalDiscount: 0
              };
            }
            pnrData[passenger.pnr].seatNumbers.push(passenger.seat_number);
            pnrData[passenger.pnr].totalDiscountedFare += (passenger.discounted_fare || 0);
            pnrData[passenger.pnr].totalGst += (passenger.total_gst || 0);
            pnrData[passenger.pnr].totalAmountPaid += (passenger.amount_paid || 0);
            pnrData[passenger.pnr].totalDiscount += (passenger.direct_discount || 0);
          }
        });
      }else{
      // Handle direct seat PNR
      if (isValid(seat.pnr)) {
        if (!pnrData[seat.pnr]) {
          pnrData[seat.pnr] = {
            seatNumbers: [],
            totalDiscountedFare: 0,
            totalGst: 0,
            totalAmountPaid: 0,
            totalDiscount: 0
          };
        }
        pnrData[seat.pnr].seatNumbers.push(seat.seat_number);
        pnrData[seat.pnr].totalDiscountedFare += (seat.discounted_cost_without_gst || 0);
        pnrData[seat.pnr].totalGst += (seat.total_gst || 0);
        pnrData[seat.pnr].totalAmountPaid += (seat.amount_paid || 0);
        pnrData[seat.pnr].totalDiscount += (seat.direct_discount || 0);
      }
      }
    });

    // Second pass: Assign totals to all seats
    scheduleSeats.forEach((seat) => {
      // Handle direct seat PNR
      if (isValid(seat.pnr)) {
        if (!pnrData[seat.pnr]) {
          pnrData[seat.pnr] = {
            seatNumbers: [],
            totalDiscountedFare: 0,
            totalGst: 0,
            totalAmountPaid: 0,
            totalDiscount: 0
          };
        }
        seat.seats_with_same_pnr = pnrData[seat.pnr].seatNumbers;
        seat.total_discounted_fare = pnrData[seat.pnr].totalDiscountedFare;
        seat.total_gst = pnrData[seat.pnr].totalGst;
        seat.total_amount_paid = pnrData[seat.pnr].totalAmountPaid;
        seat.total_discount = pnrData[seat.pnr].totalDiscount;
      } else {
        seat.seats_with_same_pnr = [];
        seat.total_discounted_fare = 0;
        seat.total_gst = 0;
        seat.total_amount_paid = 0;
        seat.total_discount = 0;
      }
      
      // Handle passenger PNRs
      if (isValidArrayWithValues(seat.passengers)) {
        seat.passengers.forEach((passenger) => {
          if (isValid(passenger.pnr)) {
            if (!pnrData[seat.pnr]) {
              pnrData[seat.pnr] = {
                seatNumbers: [],
                totalDiscountedFare: 0,
                totalGst: 0,
                totalAmountPaid: 0,
                totalDiscount: 0
              };
            }
            passenger.seats_with_same_pnr = pnrData[passenger.pnr].seatNumbers;
            passenger.total_discounted_fare = pnrData[passenger.pnr].totalDiscountedFare;
            passenger.total_gst = pnrData[passenger.pnr].totalGst;
            passenger.total_amount_paid = pnrData[passenger.pnr].totalAmountPaid;
            passenger.total_discount = pnrData[passenger.pnr].totalDiscount;
          } else {
            passenger.seats_with_same_pnr = [];
            passenger.total_discounted_fare = 0;
            passenger.total_gst = 0;
            passenger.total_amount_paid = 0;
            passenger.total_discount = 0;
          }
        });
      }
    });

    return scheduleSeats;
  }
  
  export const homeReducer = (state = initialState,action) => {
      let newState = Object.assign({},state);
      switch (action.type) {  
          
          case SET_ORIGIN_CITIES :
                newState["origins"] = action.payload;
                return newState;
            
          case SET_DESTINATION_CITIES :
                newState["originSupportedDestinations"] = action.payload;
                return newState;
          
          case SET_SELECTED_SCHEDULE_SEATS :
                newState["selectedScheduleSeats"] = formatScheduleSeats(action.payload);
                return newState;

          case SET_SELECTED_SCHEDULE : 
                newState["selectedSchedule"] = action.payload;
                return newState;

         case SET_BOOKED_TICKET:
            newState["bookedTicketObject"] = action.payload;
            return newState;

        case SET_PICK_UP_POINTS_DETAILS_SELECTED_SCHEDULE:
            newState["selectedSchedule"]["pickupTimingsByTripCity"]= action.payload;
            return newState;

        case SET_DROP_UP_POINTS_DETAILS_SELECTED_SCHEDULE:
            newState["selectedSchedule"]["dropTimingsByTripCity"]= action.payload;
            return newState;

          case LOG_OUT_ACTION :
            return initialState;

          default:
              return state;
      }
  }
  